import React, { useEffect, useState } from "react";
import { Container, Lesson, HeaderRight } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import { MdDownload } from "react-icons/md";
import { useQuery } from "./../../../hooks/Location";
import HeaderCourse from "../../../components/headerCourse";
import { useAuth } from "../../../hooks/AuthContext";
import { Button, Checkbox, Spin } from "antd";

export default function CoursePublic() {
  const { user } = useAuth();

  const query = useQuery();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1200px)",
  });

  const { course_id } = useParams();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [lessons, setLessons] = useState([]);
  const [lesson, setLesson] = useState(0);
  const [error, setError] = useState(0);
  const [urlValida, setUrlValida] = useState(false);

  useEffect(() => {
    try {
      const testUrl = new URL(lessons[lesson]?.video);
      if (testUrl.protocol === "http:" || testUrl.protocol === "https:") {
        setUrlValida(true);
      } else {
        setUrlValida(false);
      }
    } catch {
      setUrlValida(false);
    }
  }, [lessons, lesson]);

  useEffect(() => {
    redirect();
  }, []);

  function redirect() {
    if (user.type == "admin") {
      listLessons();
    } else {
      if (user.type == "cliente" && user.course) {
        listLessons();
      } else {
        navigate(-1);
      }
    }
  }

  async function listLessons() {
    await api
      .get(`/${user.type == "admin" ? "admin-" : ""}course/${course_id}`)
      .then((response) => {
        setLessons(response.data.lessons);
        let id = query.get("id");
        if (id) {
          response.data.lessons.map((item, index) => {
            if (item.id == id) {
              setLesson(index);
            }
          });
        }
      })
      .catch(({ response }) => {
        setError("Erro Interno. verifique sua conexão e tente novamente");
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
              setError(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function confirmLesson(index) {
    await api
      .post(`/confirm-lesson/${lessons[index]?.id}`)
      .then((response) => {
        let lessonsC = [...lessons];
        lessonsC[index].confirms = [response.data];
        setLessons(lessonsC);
        toast.success("Aula confirmada com sucesso");
      })
      .catch(({ response }) => {
        setError("Erro Interno. verifique sua conexão e tente novamente");
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
              setError(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <HeaderCourse name={""} />
      {loading ? (
        <Spin size={"large"} style={{ marginTop: 50 }} />
      ) : (
        <>
          <div className="lessonHeader">
            <Lesson>
              <h3>{lessons[lesson]?.name}</h3>
              {lessons[lesson]?.description && (
                <p>{lessons[lesson]?.description}</p>
              )}
              {lessons[lesson]?.video && urlValida && (
                <iframe
                  src={lessons[lesson]?.video}
                  frameborder="0"
                  allow="autoplay; encrypted-media; fullscreen;"
                  allowfullscreen
                  title="video"
                />
              )}
              {lessons[lesson]?.file_url && (
                <div
                  style={{ width: "100%", marginTop: 25 }}
                  onClick={() => {
                    window.open(lessons[lesson]?.file_url);
                  }}
                >
                  <h3>{lessons[lesson]?.file_name || "Material"}</h3>
                  <Button
                    type="primary"
                    style={{
                      borderRadius: 50,
                      fontWeight: 500,
                      padding: "20px 25px 20px 20px",
                    }}
                  >
                    <MdDownload size={25} color="#fff" />
                    Download
                  </Button>
                </div>
              )}
            </Lesson>
            <HeaderRight>
              <h4>Conteúdo do curso</h4>
              {lessons.map((item, index) => {
                return (
                  <div
                    onClick={() => {
                      if (user.type == "admin") {
                        setLesson(index);
                      } else {
                        if (index == 0 || lessons[index - 1].confirms.length) {
                          setLesson(index);
                        } else {
                          toast.warn("Confirme a aula anterior para avançar");
                        }
                      }
                    }}
                    className={
                      index == 0 || lessons[index - 1].confirms.length
                        ? lesson == index
                          ? "lesson"
                          : ""
                        : "disabled"
                    }
                  >
                    <h4>Aula {index + 1}</h4>
                    <p>{item.name}</p>
                    {user.type != "admin" && (
                      <Checkbox
                        checked={lessons[index]?.confirms.length}
                        onChange={() => {
                          if (lesson == index) {
                            confirmLesson(index);
                          } else {
                            toast.warn(
                              "Assista a aula para confirmar presença"
                            );
                          }
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </HeaderRight>
          </div>
        </>
      )}
    </Container>
  );
}
